module.exports = __webpack_public_path__ + "img/white-info.52aa08b4.svg";